import { InterfaceRef } from "./interfaces";
import type { TypeFor, TypeRef, TypeRefFor } from "./types";


export interface RecordTypeRef<T = any>
{
    name: string;
    itemType: TypeRefFor<T>;
}

export namespace RecordTypeRef
{
    export function get<T>(itemType: InterfaceRef<T>): RecordTypeRef<T>;
    export function get<T extends TypeRef>(itemType: T): RecordTypeRef<TypeFor<T>>;
    export function get(itemType: TypeRef): RecordTypeRef
    {
        let recordType = recordTypes.get(itemType);
        if (recordType)
            return recordType;

        const typeName = `Record<, ${itemType.name}>`;

        const recordIfaceRef =
            InterfaceRef.define<{}>(
                typeName,
                {
                }
            );

        recordType =
            Object.assign(
                recordIfaceRef,
                {
                    itemType
                },
                {
                    [recordKey]: recordKey
                }
            );

        recordTypes.set(itemType, recordType);

        return recordType;
    }

    export function isRecordTypeRef(value: unknown): value is RecordTypeRef;
    export function isRecordTypeRef(value: any): value is RecordTypeRef
    {
        if (!value)
            return false;
        return !!value[recordKey];
    }


    const recordKey = Symbol("Record");
    const recordTypes = new Map<TypeRef, RecordTypeRef>();
}


export const isRecordTypeRef = RecordTypeRef.isRecordTypeRef;


export const RecordOf = RecordTypeRef.get;
